import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      "guide": {
        "title": "Comprendre la Finance",
        "subtitle": "sans le mal de tête.",
        "desc": "Un guide transparent pour comprendre votre philosophie d'investissement, nos algorithmes, et transformer le jargon en décisions claires.",
        "cta_title": "Prêt à passer à la pratique ?",
        "cta_desc": "Maintenant que vous comprenez la mécanique, laissez l'algorithme travailler pour vous.",
        "cta_btn": "Lancer le Screener",
        "tab_cqp": "Philosophie CQP",
        "tab_algo": "Algorithme DCA",
        "tab_val": "Est-ce cher ?",
        "tab_qual": "Est-ce rentable ?",
        "tab_health": "Santé & Risque",
        "tab_concepts": "Concepts Clés",
        "tab_accounting": "Lire un Bilan"
      },

      "landing": {
        "hero_badge": "v2.0 Disponible • Voir les changements",
        "hero_title1": "Investissez avec la",
        "hero_title2": "Précision des Pros.",
        "hero_subtitle": "Arrêtez de deviner. KeyForIn centralise vos portefeuilles, décrypte les données complexes et automatise l'analyse fondamentale selon la méthode CQP.",
        "btn_register": "Créer mon compte",
        "btn_analyses": "Lire nos analyses",
        "method_subtitle": "Notre Philosophie",
        "method_title": "La Stratégie de Croissance Qualité à Prix Raisonnable (CQP)",
        "method_desc": "Une approche synthétique visant à identifier et à conserver sur le long terme des entreprises exceptionnelles, sans surpayer leur valeur.",
        "method_step1_title": "1. La Qualité avant tout",
        "method_step1_desc": "Nous identifions les entreprises possédant un avantage concurrentiel durable (\"Moat\"). Capacité à maintenir des marges élevées.",
        "method_step2_title": "2. La Croissance moteur",
        "method_step2_desc": "La stratégie CQP cible les sociétés capables de faire croître leurs revenus et bénéfices de manière constante.",
        "method_step3_title": "3. La Discipline du Prix",
        "method_step3_desc": "Même la meilleure entreprise est un mauvais investissement si elle est payée trop cher. Nous attendons un point d'entrée raisonnable.",
        "method_horizon_title": "L'Horizon : Long Terme (Buy & Hold)",
        "method_horizon_desc": "La véritable valeur d'une entreprise de qualité se révèle avec le temps. Les dividendes ne sont pas l'objectif premier, mais sont considérés comme une preuve de santé financière et un puissant accélérateur de performance via leur réinvestissement.",
        "tools_title": "L'arsenal complet de l'investisseur",
        "tools_desc": "Une suite d'outils analytiques pointus pour prendre de meilleures décisions, plus rapidement.",
        "tool1_title": "Portfolio Tracker",
        "tool1_desc": "Suivez l'allocation et la valeur de vos investissements en temps réel. Comparez directement vos performances face au S&P 500.",
        "tool2_title": "Screener Mondial",
        "tool2_desc": "Filtrez plus de 50 000 actions par P/E, croissance, secteur et pays. Identifiez les pépites CQP en un clic.",
        "tool3_title": "Juste Prix Intéractif",
        "tool3_desc": "Fini les boîtes noires. Ajustez les modèles de valorisation (DCF, Graham, P/E historique) et trouvez votre marge de sécurité.",
        "tool4_title": "Synchro IBKR",
        "tool4_desc": "Connectez votre compte Interactive Brokers. Vos transactions et liquidités sont importées et catégorisées automatiquement.",
        "tool5_title": "Radar des Initiés",
        "tool5_desc": "Traquez les mouvements internes : achats des PDG, directeurs financiers et membres du congrès américain (Insiders).",
        "tool6_title": "Calendrier & Dividendes",
        "tool6_desc": "Visualisez vos futurs revenus passifs, et ne manquez aucune date de publication de résultats ou de split d'actions.",
        "tool7_title": "Données Fondamentales",
        "tool7_desc": "Accédez aux bilans, comptes de résultats et flux de trésorerie sur des décennies. Profitez des diagrammes de Sankey.",
        "tool8_title": "Assistant d'Analyse",
        "tool8_desc": "Besoin d'un deuxième avis ? Un assistant intelligent synthétise les fondamentaux pour vous rédiger des thèses rapides.",
        "footer_rights": "KeyForIn © 2026",
        "footer_analyses": "Analyses",
        "footer_sectors": "Secteurs",
        "footer_news": "Nouveautés",
        "footer_help": "Aide",
        "footer_login": "Connexion"
      },
      "header": {
        "analyses": "Analyses",
        "sectors": "Secteurs",
        "dashboard": "Dashboard",
        "portfolio": "Portefeuille",
        "watchlist": "Watchlist",
        "tools": "Outils",
        "screener": "Screener",
        "screener_desc": "Filtrer le marché mondial",
        "compare": "Comparer",
        "compare_desc": "Face-à-face fondamental",
        "fair_value": "Juste Prix",
        "fair_value_desc": "Calcul de la Fair Value",
        "arena": "Arène",
        "arena_desc": "Bataille des investisseurs",
        "insiders": "Radar Initiés",
        "insiders_desc": "Traquer les achats des PDG",
        "calendar": "Calendrier",
        "calendar_desc": "Résultats & Dividendes",
        "public_content": "Contenu Public",
        "member_area": "Espace Membre",
        "my_account": "Mon Compte",
        "admin_area": "Espace Admin",
        "logout": "Déconnexion",
        "login": "Connexion",
        "register": "S'inscrire",
        "notifications": "Notifications",
        "refresh": "Actualiser",
        "no_notifs": "Rien à signaler pour l'instant 😴"
      },
      "dashboard": {
        "sync_title": "Synchronisation du Cockpit...",
        "sync_desc": "Analyse de vos données financières en cours",
        "last_update": "Dernière mise à jour à",
        "greeting_morning": "Bonjour",
        "greeting_afternoon": "Bon après-midi",
        "greeting_evening": "Bonsoir",
        "investor": "Investisseur",
        "subtitle": "Voici la vue stratégique de vos actifs aujourd'hui.",
        "net_value": "Valeur Nette",
        "invested": "Investi",
        "cash": "Cash",
        "unrealized_pnl": "P&L Latent",
        "on_invested": "sur l'investi",
        "annual_income": "Rente Annuelle",
        "yield": "Yield",
        "this_month": "Ce mois-ci",
        "collections_of": "Encaissements de",
        "perf_history": "Historique de Performance",
        "sector_allocation": "Allocation Sectorielle",
        "sectors": "Secteurs",
        "heavyweights": "Poids Lourds",
        "top_performers": "Top Performers",
        "no_gains": "Aucune plus-value pour le moment.",
        "under_watch": "Sous Surveillance",
        "no_losses": "Aucune moins-value !"
      },
      "portfolio": {
        "title_portfolios": "Portefeuilles",
        "btn_transaction": "Transaction",
        "btn_cash": "Cash",
        "btn_collection": "Encaissement",
        "btn_exchange": "Change",
        "btn_pdf": "PDF",
        "btn_import": "Import IBKR",
        "btn_refresh": "Actualiser",
        "tab_positions": "Positions",
        "tab_dca": "DCA / Analyse",
        "tab_radar": "Radar Tactique",
        "radar_title": "Radar Technique & Tendance",
        "radar_desc": "Vue tactique court et moyen terme basée sur l'action des prix et les moyennes mobiles.",
        "radar_col_trend50": "Tendance (SMA 50)",
        "radar_col_trend200": "Fond (SMA 200)",
        "radar_col_verdict": "Verdict Tactique",

        "tab_dividends": "Dividendes",
        "tab_journal": "Journal",
        "tab_analysis": "Analyse",
        "tab_correlation": "Corrélation",
        "tab_performance": "Performance",
        "tab_arena": "Arène des Titans",
        "welcome": "Bienvenue",
        "create_pf": "Créer un portefeuille",
        "stats_total_val": "Valeur Totale",
        "stats_latent": "(Latent)",
        "stats_ytd": "Perf. YTD",
        "stats_ytd_sub": "Depuis 1er Janv.",
        "stats_1y": "Perf. 1 An",
        "stats_1y_sub": "Glissant",
        "stats_total": "Total Return",
        "stats_total_sub": "Depuis création",
        "stats_hold": "Détention Moy.",
        "stats_hold_sub": "Années",
        "stats_turnover": "Turnover",
        "stats_turnover_sub": "Rotation 1 an",
        "stats_3y": "Perf. 3 Ans",
        "assets_title": "Vos Actifs (P&L Latent Strict)",
        "ungroup": "Dégrouper",
        "group_category": "Grouper par Catégorie",
        "no_active": "Aucune position active.",
        "col_title": "Titre",
        "col_qty": "Qté",
        "col_pru": "PRU",
        "col_price": "Cours",
        "col_val": "Val. Global",
        "col_pnl": "PV/MV Latente",
        "col_weight": "Poids",
        "col_actions": "Actions",
        "sell_strategy": "Stratégie de vente",
        "assets_count": "actifs",
        "div_growth": "Croissance Dividendes",
        "perf_bench": "Performance vs Benchmark",
        "my_portfolio": "Mon Portefeuille",
        "no_data": "Données insuffisantes.",
        "cat_lynch": "Catégories (Lynch)",
        "allocation": "Allocation",
        "sectors": "Secteurs",
        "countries": "Pays",
        "industries": "Industries",
        "cal_received": "Calendrier Reçus",
        "cal_forecast": "Calendrier Prévisionnel",
        "estimated": "ESTIMÉ",
        "history_empty": "Aucun historique.",
        "filter_symbol": "Symbole...",
        "type_all": "Tous types",
        "type_buy": "Achat",
        "type_sell": "Vente",
        "type_div": "Dividende",
        "type_dep": "Dépôt",
        "type_with": "Retrait",
        "type_tax": "Taxe",
        "col_date": "Date",
        "col_type": "Type",
        "col_note": "Note",
        "risk_volatility": "Volatilité (Beta)",
        "risk_sharpe": "Sharpe Ratio",
        "risk_drawdown": "Max Drawdown",
        "risk_divgrowth": "Croissance Div.",
        "dca_title": "Stratégie Quantamentale (V4.0)",
        "dca_desc": "Analyse hybride (Fondamentale + Technique) pour optimiser vos points d entrée.",
        "dca_budget": "Budget",
        "dca_calc": "Calculer"
      },
      "watchlist": {
        "title": "Mes Watchlists",
        "subtitle": "Suivez vos cibles d'investissement.",
        "btn_find": "Trouver des actions",
        "btn_new_folder": "Nouveau dossier",
        "assets_count": "Titres",
        "btn_add": "Ajouter",
        "empty_folder": "Ce dossier est vide.",
        "add_now": "Ajouter une action maintenant",
        "stock": "Action",
        "btn_analysis": "Analyse",
        "btn_buy": "Acheter",
        "welcome_title": "Créez votre première liste pour commencer",
        "btn_create_folder": "Créer un dossier",
        "modal_new_folder": "Nouveau Dossier",
        "modal_rename_folder": "Renommer le Dossier",
        "placeholder_name": "Nom...",
        "btn_create": "Créer",
        "btn_save": "Sauvegarder",
        "modal_add_stock": "Ajouter une Action",
        "placeholder_symbol": "Symbole (ex: AAPL)",
        "modal_move_stock": "Déplacer",
        "move_to": "Vers quel dossier ?",
        "move_choose": "Choisir...",
        "btn_move": "Déplacer",
        "modal_buy_stock": "Acheter",
        "buy_to_portfolio": "Vers quel portefeuille ?",
        "buy_qty": "Quantité",
        "buy_price": "Prix Unitaire",
        "buy_currency": "Devise",
        "buy_commission": "Commission",
        "buy_date": "Date",
        "buy_time": "Heure",
        "buy_notes": "Notes",
        "buy_notes_placeholder": "Pourquoi j'achète ?",
        "btn_confirm_buy": "Confirmer l'achat",
        "alert_delete_folder": "Supprimer ce dossier définitivement ?",
        "alert_remove_stock": "Retirer",
        "alert_buy_success": "Ordre exécuté avec succès !"
      },
      "compare": {
        "badge": "Outil d'Analyse",
        "title": "Comparateur d'Actions",
        "subtitle": "Confrontation des fondamentaux selon les méthodes des grands investisseurs.",
        "search_placeholder": "Ex: AAPL, MSFT, V...",
        "alert_max": "Vous pouvez comparer un maximum de 5 actions simultanément.",
        "alert_not_found": "introuvable",
        "alert_error": "Erreur de connexion.",
        "empty_title": "L'Arène est vide",
        "empty_desc": "Ajoutez des entreprises via la barre de recherche pour démarrer la comparaison.",
        "tab_general": "Vue Générale",
        "tab_lynch": "Filtre Peter Lynch",
        "tab_buffett": "Filtre Warren Buffett",
        "col_fundamentals": "Fondamentaux",
        "gen_base": "Base",
        "gen_market_cap": "Capitalisation",
        "gen_pe": "Ratio P/E",
        "gen_pe_ttip": "Price-to-Earnings. Combien d'années de bénéfices faut-il pour rembourser le prix de l'action.",
        "gen_yield": "Dividend Yield",
        "gen_scores": "Scores Globaux",
        "gen_piotroski": "Score Piotroski (Sur 9)",
        "gen_piotroski_ttip": "Solidité financière globale. 7 à 9 = Excellent.",
        "gen_altman": "Score Altman Z",
        "gen_altman_ttip": "Risque de faillite. > 3 = Sûr.",
        "lynch_garp": "GARP & Croissance",
        "lynch_peg": "Ratio PEG",
        "lynch_peg_ttip": "P/E divisé par Croissance. < 1 = Sous-évaluée. < 0.5 = Opportunité en or.",
        "lynch_eps_growth": "Croissance EPS (5 Ans)",
        "lynch_eps_ttip": "Croissance moyenne annualisée. Lynch cherche idéalement entre 15% et 25%.",
        "lynch_management": "Direction & Bilan",
        "lynch_debt_eq": "Dette / Capitaux Propres",
        "lynch_debt_eq_ttip": "Lynch fuit les bilans surendettés. Ratio < 0.5 = Très sain.",
        "lynch_buyback": "Buyback Yield",
        "lynch_buyback_ttip": "Rachats d'actions. Un signal d'achat très fort pour Lynch !",
        "lynch_insider": "Parts Initiés",
        "lynch_insider_ttip": "Actions détenues par la direction. Skin in the game.",
        "buf_moat": "Economic Moat (Avantage)",
        "buf_roe": "ROE (Retour sur Capitaux Propres)",
        "buf_roe_ttip": "LA métrique numéro 1 de Buffett. Révèle l'avantage compétitif. > 15% est le minimum vital pour lui.",
        "buf_gross_margin": "Marge Brute",
        "buf_gross_ttip": "Indicateur de 'Pricing Power'. Buffett adore les entreprises dont la marge brute est > 40%.",
        "buf_net_margin": "Marge Nette",
        "buf_net_ttip": "Une marge nette > 20% témoigne d'un monopole ou d'un avantage de coût écrasant.",
        "buf_efficiency": "Efficacité & Bilan",
        "buf_capex": "CapEx / Cash Flow Ops",
        "buf_capex_ttip": "Pourcentage du Cash Flow dépensé pour maintenir l'outil industriel. Buffett veut des entreprises 'Asset-Light' (< 25%).",
        "buf_debt_payoff": "Années pour rembourser Dette",
        "buf_debt_payoff_ttip": "Dette Totale / Résultat Net. Doit pouvoir être remboursée en moins de 3 à 4 ans.",
        "chart_quality": "Qualité Business",
        "chart_roic_desc": "ROIC (%) - Plus haut = Mieux",
        "chart_yield": "Rendement Actionnaire",
        "chart_yield_desc": "Dividend Yield (%)",
        "chart_garp": "Croissance à Prix Raisonnable",
        "chart_peg_desc": "Ratio PEG - Plus bas = Mieux",
        "chart_moat": "Avantage Concurrentiel",
        "chart_roe_desc": "ROE (%) - Plus haut = Mieux",
        "chart_pricing": "Pricing Power",
        "chart_margin_desc": "Marge Brute (%) - Plus haut = Mieux",
        "cqp_verdict_title": "Verdict CQP (Croissance, Qualité, Prix)",
        "cqp_winner_is": "Le grand gagnant est",
        "cqp_with": "avec",
        "cqp_pts": "pts.",
        "cqp_desc_1": "Selon notre algorithme CQP (Croissance 30%, Qualité 40%, Prix 30%),",
        "cqp_desc_2": "s'impose face à ses concurrents.",
        "cqp_q_high": " L'entreprise brille par sa rentabilité exceptionnelle et sa solidité financière (Qualité).",
        "cqp_p_high": " Sa valorisation reste très attractive par rapport à sa croissance (Prix raisonnable).",
        "cqp_c_high": " Elle affiche également une forte dynamique d'expansion (Croissance).",
        "cqp_c_label": "[C] Croissance",
        "cqp_q_label": "[Q] Qualité",
        "cqp_p_label": "[P] Prix (Valo)"
      },
      "blog": {
        "badge": "Journal des mises à jour",
        "title": "Quoi de neuf sur KeyForIn ?",
        "idea_title": "Une idée de fonctionnalité ?",
        "btn_contact": "Nous contacter",
        "posts": [
          {
            "id": 11,
            "date": "15 Mar 2026",
            "category": "Majeur",
            "title": "L'Ère de l'Intelligence Artificielle & Outils Pro",
            "color": "indigo",
            "content": "Une mise à jour historique pour KeyForIn ! Nous avons intégré notre tout nouveau Copilote IA (propulsé par Gemini 2.5 Flash) directement dans vos fiches actions pour générer instantanément des thèses d'investissement CQP. Le module 'Juste Prix' a été transformé en un véritable Laboratoire Interactif (ajustez vos propres taux de croissance en temps réel). Nous avons également lancé le Radar des Initiés (Insiders), le Calendrier des Catalyseurs, et entièrement repensé le Screener et la navigation pour une expérience digne des meilleurs terminaux de Wall Street.",
            "features": ["Copilote IA (Gemini 2.5)", "Laboratoire de Valorisation Interactif", "Radar des Initiés & Calendrier", "Nouveau Screener CQP & UX Premium"]
          },
          {
            "id": 10,
            "date": "31 Jan 2026",
            "category": "Majeur",
            "title": "Terminal Financier Complet",
            "color": "rose",
            "content": "La fiche action atteint sa version finale ! Explorez la répartition des revenus via le nouveau diagramme de Sankey interactif, consultez les objectifs de prix et prévisions des analystes (Revenus & EPS futurs), et suivez l'actualité spécifique à chaque titre. Nous avons également stabilisé le chargement des données financières et optimisé l'architecture globale.",
            "features": ["Diagramme de Flux (Sankey)", "Prévisions & Cibles Analystes", "Fil Actualités", "Optimisation Backend"]
          },
          {
            "id": 9,
            "date": "27 Jan 2026",
            "category": "Majeur",
            "title": "Analytique 2.0 & Fiabilité",
            "color": "emerald",
            "content": "Une mise à jour critique pour la précision de vos données. Nous avons réécrit le moteur de calcul pour éliminer les effets 'dents de scie' sur les courbes de performance (gestion intelligente des week-ends). La Matrice de Corrélation et le Calendrier des Dividendes ont été rendus plus robustes : ils s'affichent désormais même si l'historique de certaines actions est incomplet. La génération PDF a également été sécurisée.",
            "features": ["Courbes Lisses (Smart Fill)", "Corrélation Robuste", "Dividendes Glissants (12 mois)", "PDF Sécurisé"]
          },
          {
            "id": 8,
            "date": "24 Jan 2026",
            "category": "Majeur",
            "title": "Confort Visuel & Précision",
            "color": "purple",
            "content": "Une grosse mise à jour visuelle et fonctionnelle ! La courbe de performance compare désormais votre portefeuille au S&P 500 avec une précision absolue (ligne rouge). Les graphiques d'analyse affichent maintenant 100% des détails (fin du regroupement 'Autres'). De plus, vous pouvez saisir des dividendes manuels ('Encaissement') et justifier vos choix grâce au nouveau champ 'Journal de Bord' dans les transactions.",
            "features": ["Benchmark S&P 500 Fiabilisé", "Journal de Bord (Thèse)", "Analyse 100% détaillée", "Saisie Dividendes Manuels"]
          },
          {
            "id": 7,
            "date": "21 Jan 2026",
            "category": "Majeur",
            "title": "Performance Benchmark & Dividendes Futurs",
            "color": "blue",
            "content": "Mesurez votre surperformance ! Le nouvel onglet Performance compare désormais votre portefeuille face au S&P 500 en temps réel. Nous avons aussi ajouté la projection annuelle de vos dividendes (basée sur le dernier versement), des badges 'Bagger' pour vos meilleures lignes, et amélioré l'import IBKR pour gérer les conversions de devises (Forex).",
            "features": ["Benchmark S&P 500", "Dividendes Estimés", "Support Forex (XML)", "Badges 'Bagger'"]
          },
          {
            "id": 6,
            "date": "11 Jan 2026",
            "category": "Majeur",
            "title": "Gestion des Risques & Opérations sur Titres",
            "color": "orange",
            "content": "Votre gestion de portefeuille passe au niveau supérieur. Analysez la diversification réelle de vos actifs grâce à la nouvelle Matrice de Corrélation. Nous avons également ajouté la gestion complète des Opérations Sur Titres (Splits, Spin-offs), l'édition des transactions passées et un Journal des Liquidités unifié.",
            "features": ["Matrice de Corrélation", "Gestion Splits & Spin-offs", "Édition & Correction", "Journal Cash & Dividendes"]
          },
          {
            "id": 5,
            "date": "09 Jan 2026",
            "category": "Majeur",
            "title": "Automatisation IBKR & Journal",
            "color": "pink",
            "content": "Une mise à jour massive : connectez votre compte Interactive Brokers pour une synchronisation automatique (Flex Query), analysez vos dividendes réels vs prévisionnels et notez vos thèses d'investissement.",
            "features": ["Sync Auto IBKR", "Import XML", "Journal de Bord", "Dividendes Réels"]
          },
          {
            "id": 4,
            "date": "08 Jan 2026",
            "category": "Feature",
            "title": "Analyse Fondamentale 360° & Profil",
            "color": "indigo",
            "content": "Nous avons transformé la page Action en un terminal d'analyse professionnel. Accédez désormais aux états financiers complets sur 5 ans (Bilan, Résultat, Cash Flow), à la ventilation géographique des revenus, aux prévisions d'analystes, et à un score de sécurité du dividende exclusif. Une page Profil a également été ajoutée.",
            "features": ["États Financiers 5 ans", "Ventilation Revenus", "Prévisions & Objectifs", "Score Dividende & Buyback"]
          },
          {
            "id": 3,
            "date": "25 Oct 2025",
            "category": "Feature",
            "title": "Le Screener est arrivé !",
            "color": "blue",
            "content": "Filtrez plus de 50 000 actions par capitalisation, secteur et pays.",
            "features": ["Filtres multicritères", "Ajout Watchlist", "Achat direct"]
          },
          {
            "id": 2,
            "date": "20 Oct 2025",
            "category": "Amélioration",
            "title": "Graphiques & Analyse",
            "color": "green",
            "content": "Nouvelle page détail avec historique interactif et méthode Peter Lynch.",
            "features": ["Graphique 5 ans", "Fair Value", "CAGR"]
          },
          {
            "id": 1,
            "date": "01 Oct 2025",
            "category": "Lancement",
            "title": "KeyForIn v1.0",
            "color": "purple",
            "content": "Lancement officiel. Gérez vos portefeuilles PEA/CTO simplement.",
            "features": ["Multi-portefeuilles", "Calcul PRU", "Suivi Devises"]
          }
        ]
      },
      "login": {
        "error_msg": "Identifiants incorrects ou compte en attente de validation.",
        "badge_philo": "Philosophie KeyForIn",
        "title_main": "Stratégie de Croissance Qualité à Prix Raisonnable",
        "title_garp": "(CQP)",
        "subtitle": "Cette approche vise à identifier et conserver sur le long terme des entreprises exceptionnelles, sans surpayer leur valeur.",
        "step1_title": "1. La Qualité (Fisher & Buffett)",
        "step1_desc": "Nous cherchons des entreprises avec un avantage concurrentiel durable (\"moat\") garantissant des profits élevés pour les décennies à venir.",
        "step2_title": "2. La Croissance (Peter Lynch)",
        "step2_desc": "La qualité ne suffit pas sans perspective. Nous visons une croissance des revenus et bénéfices supérieure à la moyenne du marché.",
        "step3_title": "3. La Discipline (Graham)",
        "step3_desc": "Même la meilleure entreprise est un mauvais investissement si elle est surpayée. Nous attendons le juste prix.",
        "horizon": "Horizon long terme \"Buy and Hold\"",
        "welcome_back": "Bon retour !",
        "login_desc": "Connectez-vous pour accéder au Cockpit.",
        "email_label": "Email Utilisateur",
        "email_placeholder": "jean@exemple.com",
        "password_label": "Mot de passe",
        "password_placeholder": "••••••••",
        "btn_loading": "Connexion en cours...",
        "btn_login": "Se connecter",
        "no_account": "Pas encore accès au Club ?",
        "btn_register": "Soumettre un dossier"
      },
      "register": {
        "error_msg": "Erreur lors de la candidature. Cet email est peut-être déjà en cours d'étude.",
        "club": "KeyForIn Club",
        "title_p1": "Rejoignez l'élite des",
        "title_p2": "Investisseurs.",
        "subtitle": "L'accès à la plateforme est strictement réservé. Soumettez votre dossier pour débloquer nos outils d'analyse institutionnels.",
        "feat1": "Cockpit financier sur-mesure",
        "feat2": "Screener & Smart DCA Algorithm",
        "feat3": "Accès aux portefeuilles des Gurus",
        "process_title": "Processus de sélection",
        "process_desc": "Chaque candidature est étudiée manuellement par l'administrateur pour garantir la qualité du réseau.",
        "success_title": "Candidature Reçue !",
        "success_desc": "Merci de votre intérêt pour KeyForIn. L'administrateur va examiner votre profil. Vous recevrez une notification dès que votre accès sera débloqué.",
        "btn_home": "Retour à l'accueil",
        "form_title": "Déposer un dossier",
        "form_subtitle": "Veuillez remplir le formulaire ci-dessous avec précision.",
        "label_name": "Nom complet",
        "place_name": "Ex: Jean Dupont",
        "label_email": "Email de contact",
        "place_email": "jean@exemple.com",
        "label_pwd": "Mot de passe souhaité",
        "place_pwd": "••••••••",
        "label_obj": "Votre objectif (Optionnel)",
        "place_obj": "Pourquoi souhaitez-vous rejoindre la plateforme ? (Ex: Gérer mon PEA, analyser des actions US...)",
        "btn_loading": "Envoi en cours...",
        "btn_submit": "Soumettre ma candidature",
        "already_member": "Vous avez déjà un accès ?",
        "login_here": "Connectez-vous ici"
      },
      "screener": {
        "badge": "Moteur de Recherche",
        "title": "Screener CQP",
        "subtitle": "Filtrez le marché mondial pour trouver les meilleures opportunités.",
        "label_region": "Zone Géographique",
        "region_world": "Monde Entier",
        "region_us": "États-Unis",
        "region_fr": "France",
        "region_de": "Allemagne",
        "region_uk": "Royaume-Uni",
        "region_cn": "Chine",
        "label_cap": "Capitalisation",
        "cap_all": "Toutes tailles",
        "cap_micro": "Micro Cap (> $50M)",
        "cap_small": "Small Cap (> $300M)",
        "cap_mid": "Mid Cap (> $2B)",
        "cap_large": "Large Cap (> $10B)",
        "cap_mega": "Mega Cap (> $200B)",
        "label_sector": "Secteur d'activité",
        "sector_all": "Tous les secteurs",
        "label_search": "Recherche par Nom",
        "place_search": "Ex: Apple, NVDA...",
        "check_etf": "Inclure ETF",
        "check_fund": "Inclure Fonds",
        "btn_apply": "Appliquer les filtres",
        "results_found": "Résultats trouvés",
        "empty_search": "Recherche en cours...",
        "empty_title": "Aucune pépite trouvée",
        "empty_desc": "Modifiez vos filtres ci-dessus pour trouver plus d'opportunités.",
        "col_symbol": "Symbole",
        "col_company": "Société",
        "col_sector_country": "Secteur & Pays",
        "col_price": "Prix",
        "col_cap": "Capitalisation",
        "col_actions": "Actions",
        "action_buy": "Acheter",
        "action_watch": "Watchlist",
        "action_analyze": "Analyser",
        "modal_buy_title": "Acheter",
        "modal_buy_dest": "Portefeuille de destination",
        "modal_buy_qty": "Quantité",
        "modal_buy_price": "Prix unitaire",
        "modal_buy_btn": "Exécuter l'ordre",
        "modal_watch_title": "Ajouter à la Watchlist",
        "modal_watch_select": "Sélectionnez la liste pour",
        "modal_watch_btn": "Ajouter aux favoris",
        "alert_buy": "Ordre exécuté !",
        "alert_watch": "Ajouté !"
      },
      "valuation": {
        "badge": "Laboratoire Interactif",
        "title": "Juste Prix",
        "subtitle": "Modifiez les hypothèses de croissance pour observer l'impact sur la Marge de Sécurité.",
        "placeholder": "Ex: AAPL, TSLA, MSFT...",
        "btn_analyze": "Analyser",
        "eps_base": "Bénéfice par action (EPS) de base :",
        "gauge_invalid": "Modèle inadapté (Bénéfices négatifs ou données insuffisantes).",
        "fair_value": "Juste Prix",
        "current_price": "Actuel",
        "dcf_title": "Modèle DCF (Bénéfices)",
        "dcf_desc": "Actualisation des bénéfices futurs (Earnings DCF) basée sur vos hypothèses de croissance.",
        "dcf_growth": "Croissance estimée (1-5 ans)",
        "dcf_discount": "Taux Actualisation",
        "dcf_terminal": "Multiple Terminal",
        "graham_title": "Formule de Graham",
        "graham_desc": "Évaluation basée sur les principes de Benjamin Graham adaptés à votre scénario.",
        "graham_growth": "Croissance long-terme (g)",
        "graham_default": "FMP estimation par défaut :",
        "histpe_title": "Modèle PER Historique",
        "histpe_desc": "Simulation d'un retour à la moyenne. Ajustez le PER cible par rapport à l'historique.",
        "histpe_target": "PER Cible",
        "histpe_avg": "Moyenne 5 ans de l'action :",
        "comp_title": "Modèle par Comparables",
        "comp_desc": "Valorisation relative. Ajustez le PER sectoriel pour simuler une prime de leader.",
        "comp_sector": "PER du Secteur",
        "comp_median": "Médiane des {{count}} concurrents :",
        "verdict_title": "Verdict de votre simulation",
        "verdict_models": "{{undervalued}} modèles sur {{total}}",
        "verdict_discount": "estiment que l'action offre une décote avec vos hypothèses.",
        "verdict_good": "Le consensus indique une marge de sécurité importante. C'est une potentielle opportunité.",
        "verdict_bad": "L'action semble valorisée avec une prime, prudence avec ces hypothèses.",
        "verdict_neutral": "L'entreprise est actuellement valorisée à un prix proche de sa valeur théorique (Fair Value).",
        "avg_title": "Juste Prix Moyen",
        "avg_margin": "Marge globale :",
        "footer_note": "Les modifications des curseurs mettent à jour la valorisation en temps réel sans recharger la page.",
        "alert_not_found": "introuvable.",
        "alert_error": "Erreur de connexion."
      },
      "arena": {
        "title": "Arène des Titans",
        "subtitle": "Analysez les portefeuilles officiels (SEC 13F) des légendes.",
        "btn_consensus": "Top 10 Consensus",
        "btn_sync_all": "Tout Actualiser",
        "btn_syncing": "Mise à jour...",
        "search_ph": "Chercher...",
        "alert_sync": "Mise à jour lancée !",
        "alert_sync_all": "Lancer la mise à jour complète ?",
        "alert_sync_all_ok": "🚀 Mise à jour globale lancée.",
        "alert_error": "Erreur",
        "guru_update": "Mise à jour:",
        "guru_never": "Jamais",
        "guru_btn_sync": "Sync Individuelle",
        "guru_assets": "Actifs Gérés",
        "guru_positions": "Positions",
        "guru_turnover": "Turnover",
        "guru_hold_period": "Détention",
        "guru_months": "M",
        "allocation_title": "Allocation",
        "allocation_empty": "Pas de données",
        "holdings_title": "Top Positions",
        "holdings_empty": "Aucune position.",
        "col_symbol": "Symbole",
        "col_company": "Société",
        "col_type": "Type",
        "col_value": "Valeur",
        "col_weight": "Poids",
        "empty_select": "Sélectionnez un investisseur à gauche ou cliquez sur \"Top 10 Consensus\"",
        "cons_title": "Top 10 Consensus",
        "cons_desc": "Les actions les plus plébiscitées par les {{count}} super investisseurs de votre base.",
        "cons_loading": "Calcul du consensus en cours...",
        "cons_col_rank": "Rang",
        "cons_col_holders": "Détenteurs",
        "cons_col_invested": "Investissement Total"
      }
    }
  },
  en: {
    translation: {
      "guide": {
        "title": "Understanding Finance",
        "subtitle": "without the headache.",
        "desc": "A transparent guide to understanding your investment philosophy, our algorithms, and turning jargon into clear decisions.",
        "cta_title": "Ready to practice?",
        "cta_desc": "Now that you understand the mechanics, let the algorithm work for you.",
        "cta_btn": "Launch Screener",
        "tab_cqp": "CQP Philosophy",
        "tab_algo": "DCA Algorithm",
        "tab_val": "Is it expensive?",
        "tab_qual": "Is it profitable?",
        "tab_health": "Health & Risk",
        "tab_concepts": "Key Concepts",
        "tab_accounting": "Read a Balance Sheet"
      },

      "landing": {
        "hero_badge": "v2.0 Available • See what's new",
        "hero_title1": "Invest with",
        "hero_title2": "Professional Precision.",
        "hero_subtitle": "Stop guessing. KeyForIn centralizes your portfolios, decodes complex data, and automates fundamental analysis using the GARP method.",
        "btn_register": "Create my account",
        "btn_analyses": "Read our research",
        "method_subtitle": "Our Philosophy",
        "method_title": "The Growth at a Reasonable Price (GARP) Strategy",
        "method_desc": "A synthetic approach aimed at identifying and holding outstanding companies over the long term, without overpaying for their value.",
        "method_step1_title": "1. Quality First",
        "method_step1_desc": "We identify companies with a sustainable competitive advantage (\"Moat\"). The ability to maintain high margins.",
        "method_step2_title": "2. Growth as the Engine",
        "method_step2_desc": "The GARP strategy targets companies capable of consistently growing their revenues and earnings.",
        "method_step3_title": "3. Price Discipline",
        "method_step3_desc": "Even the best company is a bad investment if you pay too much for it. We wait for a reasonable entry point.",
        "method_horizon_title": "The Horizon: Long Term (Buy & Hold)",
        "method_horizon_desc": "The true value of a quality company reveals itself over time. Dividends are not the primary goal, but are considered proof of financial health and a powerful performance accelerator through reinvestment.",
        "tools_title": "The complete investor's arsenal",
        "tools_desc": "A suite of advanced analytical tools to make better decisions, faster.",
        "tool1_title": "Portfolio Tracker",
        "tool1_desc": "Track the allocation and value of your investments in real time. Compare your performance directly against the S&P 500.",
        "tool2_title": "Global Screener",
        "tool2_desc": "Filter over 50,000 stocks by P/E, growth, sector, and country. Spot GARP gems in one click.",
        "tool3_title": "Interactive Fair Value",
        "tool3_desc": "No more black boxes. Adjust valuation models (DCF, Graham, historical P/E) and find your margin of safety.",
        "tool4_title": "IBKR Sync",
        "tool4_desc": "Connect your Interactive Brokers account. Your transactions and cash are imported and categorized automatically.",
        "tool5_title": "Insider Radar",
        "tool5_desc": "Track internal moves: buys from CEOs, CFOs, and US Congress members (Insiders).",
        "tool6_title": "Calendar & Dividends",
        "tool6_desc": "Visualize your future passive income, and never miss an earnings release or stock split date.",
        "tool7_title": "Fundamental Data",
        "tool7_desc": "Access balance sheets, income statements, and cash flows spanning decades. Enjoy Sankey diagrams.",
        "tool8_title": "Analysis Assistant",
        "tool8_desc": "Need a second opinion? A smart assistant synthesizes fundamentals to write quick investment theses for you.",
        "footer_rights": "KeyForIn © 2026",
        "footer_analyses": "Research",
        "footer_sectors": "Sectors",
        "footer_news": "Updates",
        "footer_help": "Help",
        "footer_login": "Login"
      },
      "header": {
        "analyses": "Research",
        "sectors": "Sectors",
        "dashboard": "Dashboard",
        "portfolio": "Portfolio",
        "watchlist": "Watchlist",
        "tools": "Tools",
        "screener": "Screener",
        "screener_desc": "Filter global markets",
        "compare": "Compare",
        "compare_desc": "Fundamental face-off",
        "fair_value": "Fair Value",
        "fair_value_desc": "Intrinsic value calculator",
        "arena": "Arena",
        "arena_desc": "Investor battleground",
        "insiders": "Insider Radar",
        "insiders_desc": "Track CEO purchases",
        "calendar": "Calendar",
        "calendar_desc": "Earnings & Dividends",
        "public_content": "Public Content",
        "member_area": "Member Area",
        "my_account": "My Account",
        "admin_area": "Admin Area",
        "logout": "Logout",
        "login": "Login",
        "register": "Sign Up",
        "notifications": "Notifications",
        "refresh": "Refresh",
        "no_notifs": "Nothing to report for now 😴"
      },
      "dashboard": {
        "sync_title": "Syncing Cockpit...",
        "sync_desc": "Analyzing your financial data",
        "last_update": "Last updated at",
        "greeting_morning": "Good morning",
        "greeting_afternoon": "Good afternoon",
        "greeting_evening": "Good evening",
        "investor": "Investor",
        "subtitle": "Here is the strategic view of your assets today.",
        "net_value": "Net Value",
        "invested": "Invested",
        "cash": "Cash",
        "unrealized_pnl": "Unrealized P&L",
        "on_invested": "on invested",
        "annual_income": "Annual Income",
        "yield": "Yield",
        "this_month": "This month",
        "collections_of": "Collections for",
        "perf_history": "Performance History",
        "sector_allocation": "Sector Allocation",
        "sectors": "Sectors",
        "heavyweights": "Top Holdings",
        "top_performers": "Top Performers",
        "no_gains": "No gains at the moment.",
        "under_watch": "Under Watch",
        "no_losses": "No losses! Great job."
      },
      "portfolio": {
        "title_portfolios": "Portfolios",
        "btn_transaction": "Trade",
        "btn_cash": "Cash",
        "btn_collection": "Collect",
        "btn_exchange": "FX",
        "btn_pdf": "PDF",
        "btn_import": "Import IBKR",
        "btn_refresh": "Refresh",
        "tab_positions": "Positions",
        "tab_dca": "DCA / Analysis",
        "tab_radar": "Tactical Radar",
        "radar_title": "Technical Radar & Trend",
        "radar_desc": "Short and medium-term tactical view based on price action and moving averages.",
        "radar_col_trend50": "Trend (SMA 50)",
        "radar_col_trend200": "Core (SMA 200)",
        "radar_col_verdict": "Tactical Verdict",

        "tab_dividends": "Dividends",
        "tab_journal": "Ledger",
        "tab_analysis": "Analysis",
        "tab_correlation": "Correlation",
        "tab_performance": "Performance",
        "tab_arena": "Titan Arena",
        "welcome": "Welcome",
        "create_pf": "Create a portfolio",
        "stats_total_val": "Total Value",
        "stats_latent": "(Unrealized)",
        "stats_ytd": "YTD Perf.",
        "stats_ytd_sub": "Since Jan 1st",
        "stats_1y": "1Y Perf.",
        "stats_1y_sub": "Trailing",
        "stats_total": "Total Return",
        "stats_total_sub": "Since inception",
        "stats_hold": "Avg. Holding",
        "stats_hold_sub": "Years",
        "stats_turnover": "Turnover",
        "stats_turnover_sub": "1Y Rotation",
        "stats_3y": "3Y Perf.",
        "assets_title": "Your Assets (Strict Unrealized P&L)",
        "ungroup": "Ungroup",
        "group_category": "Group by Category",
        "no_active": "No active positions.",
        "col_title": "Asset",
        "col_qty": "Qty",
        "col_pru": "Avg Price",
        "col_price": "Price",
        "col_val": "Total Val.",
        "col_pnl": "Unrealized P&L",
        "col_weight": "Weight",
        "col_actions": "Actions",
        "sell_strategy": "Sell strategy",
        "assets_count": "assets",
        "div_growth": "Dividend Growth",
        "perf_bench": "Performance vs Benchmark",
        "my_portfolio": "My Portfolio",
        "no_data": "Insufficient data.",
        "cat_lynch": "Categories (Lynch)",
        "allocation": "Allocation",
        "sectors": "Sectors",
        "countries": "Countries",
        "industries": "Industries",
        "cal_received": "Received Calendar",
        "cal_forecast": "Forecast Calendar",
        "estimated": "ESTIMATED",
        "history_empty": "No history.",
        "filter_symbol": "Symbol...",
        "type_all": "All types",
        "type_buy": "Buy",
        "type_sell": "Sell",
        "type_div": "Dividend",
        "type_dep": "Deposit",
        "type_with": "Withdraw",
        "type_tax": "Tax",
        "col_date": "Date",
        "col_type": "Type",
        "col_note": "Note",
        "risk_volatility": "Volatility (Beta)",
        "risk_sharpe": "Sharpe Ratio",
        "risk_drawdown": "Max Drawdown",
        "risk_divgrowth": "Div. Growth",
        "dca_title": "Quantamental Strategy (V4.0)",
        "dca_desc": "Hybrid analysis (Fundamental + Technical) to optimize your entry points.",
        "dca_budget": "Budget",
        "dca_calc": "Calculate"
      },
      "watchlist": {
        "title": "My Watchlists",
        "subtitle": "Track your investment targets.",
        "btn_find": "Find stocks",
        "btn_new_folder": "New folder",
        "assets_count": "Assets",
        "btn_add": "Add",
        "empty_folder": "This folder is empty.",
        "add_now": "Add a stock now",
        "stock": "Stock",
        "btn_analysis": "Analysis",
        "btn_buy": "Buy",
        "welcome_title": "Create your first list to start",
        "btn_create_folder": "Create folder",
        "modal_new_folder": "New Folder",
        "modal_rename_folder": "Rename Folder",
        "placeholder_name": "Name...",
        "btn_create": "Create",
        "btn_save": "Save",
        "modal_add_stock": "Add Stock",
        "placeholder_symbol": "Symbol (e.g., AAPL)",
        "modal_move_stock": "Move",
        "move_to": "To which folder?",
        "move_choose": "Choose...",
        "btn_move": "Move",
        "modal_buy_stock": "Buy",
        "buy_to_portfolio": "To which portfolio?",
        "buy_qty": "Quantity",
        "buy_price": "Unit Price",
        "buy_currency": "Currency",
        "buy_commission": "Commission",
        "buy_date": "Date",
        "buy_time": "Time",
        "buy_notes": "Notes",
        "buy_notes_placeholder": "Why am I buying?",
        "btn_confirm_buy": "Confirm Purchase",
        "alert_delete_folder": "Permanently delete this folder?",
        "alert_remove_stock": "Remove",
        "alert_buy_success": "Order executed successfully!"
      },
      "compare": {
        "badge": "Analysis Tool",
        "title": "Stock Comparator",
        "subtitle": "Face-to-face fundamentals based on the methods of great investors.",
        "search_placeholder": "Ex: AAPL, MSFT, V...",
        "alert_max": "You can compare a maximum of 5 stocks simultaneously.",
        "alert_not_found": "not found",
        "alert_error": "Connection error.",
        "empty_title": "The Arena is empty",
        "empty_desc": "Add companies via the search bar to start comparing.",
        "tab_general": "General View",
        "tab_lynch": "Peter Lynch Filter",
        "tab_buffett": "Warren Buffett Filter",
        "col_fundamentals": "Fundamentals",
        "gen_base": "Base",
        "gen_market_cap": "Market Cap",
        "gen_pe": "P/E Ratio",
        "gen_pe_ttip": "Price-to-Earnings. How many years of earnings are needed to pay back the stock price.",
        "gen_yield": "Dividend Yield",
        "gen_scores": "Global Scores",
        "gen_piotroski": "Piotroski Score (Out of 9)",
        "gen_piotroski_ttip": "Overall financial health. 7 to 9 = Excellent.",
        "gen_altman": "Altman Z-Score",
        "gen_altman_ttip": "Bankruptcy risk. > 3 = Safe.",
        "lynch_garp": "GARP & Growth",
        "lynch_peg": "PEG Ratio",
        "lynch_peg_ttip": "P/E divided by Growth. < 1 = Undervalued. < 0.5 = Golden opportunity.",
        "lynch_eps_growth": "EPS Growth (5Y)",
        "lynch_eps_ttip": "Annualized average growth. Lynch ideally looks for 15% to 25%.",
        "lynch_management": "Management & Balance Sheet",
        "lynch_debt_eq": "Debt to Equity",
        "lynch_debt_eq_ttip": "Lynch avoids heavily indebted balance sheets. Ratio < 0.5 = Very healthy.",
        "lynch_buyback": "Buyback Yield",
        "lynch_buyback_ttip": "Share repurchases. A very strong buy signal for Lynch!",
        "lynch_insider": "Insider Holdings",
        "lynch_insider_ttip": "Shares held by management. Skin in the game.",
        "buf_moat": "Economic Moat",
        "buf_roe": "ROE (Return on Equity)",
        "buf_roe_ttip": "Buffett's #1 metric. Reveals competitive advantage. > 15% is the vital minimum for him.",
        "buf_gross_margin": "Gross Margin",
        "buf_gross_ttip": "Indicator of 'Pricing Power'. Buffett loves companies with a gross margin > 40%.",
        "buf_net_margin": "Net Margin",
        "buf_net_ttip": "A net margin > 20% indicates a monopoly or overwhelming cost advantage.",
        "buf_efficiency": "Efficiency & Balance Sheet",
        "buf_capex": "CapEx to Cash Flow",
        "buf_capex_ttip": "Percentage of Cash Flow spent to maintain operations. Buffett wants 'Asset-Light' companies (< 25%).",
        "buf_debt_payoff": "Years to Pay Off Debt",
        "buf_debt_payoff_ttip": "Total Debt / Net Income. Should be able to be paid off in less than 3 to 4 years.",
        "chart_quality": "Business Quality",
        "chart_roic_desc": "ROIC (%) - Higher = Better",
        "chart_yield": "Shareholder Return",
        "chart_yield_desc": "Dividend Yield (%)",
        "chart_garp": "Growth at a Reasonable Price",
        "chart_peg_desc": "PEG Ratio - Lower = Better",
        "chart_moat": "Competitive Advantage",
        "chart_roe_desc": "ROE (%) - Higher = Better",
        "chart_pricing": "Pricing Power",
        "chart_margin_desc": "Gross Margin (%) - Higher = Better",
        "cqp_verdict_title": "GARP Verdict (Growth, Quality, Price)",
        "cqp_winner_is": "The grand winner is",
        "cqp_with": "with",
        "cqp_pts": "pts.",
        "cqp_desc_1": "According to our GARP algorithm (Growth 30%, Quality 40%, Price 30%),",
        "cqp_desc_2": "prevails against its competitors.",
        "cqp_q_high": " The company shines with exceptional profitability and financial strength (Quality).",
        "cqp_p_high": " Its valuation remains very attractive relative to its growth (Reasonable Price).",
        "cqp_c_high": " It also displays strong expansion momentum (Growth).",
        "cqp_c_label": "[G] Growth",
        "cqp_q_label": "[Q] Quality",
        "cqp_p_label": "[P] Price (Valuation)"
      },
      "blog": {
        "badge": "Update Log",
        "title": "What's new on KeyForIn?",
        "idea_title": "Got a feature idea?",
        "btn_contact": "Contact us",
        "posts": [
          {
            "id": 11,
            "date": "Mar 15, 2026",
            "category": "Major",
            "title": "The Era of Artificial Intelligence & Pro Tools",
            "color": "indigo",
            "content": "A historic update for KeyForIn! We have integrated our brand new AI Copilot (powered by Gemini 2.5 Flash) directly into your stock sheets to instantly generate GARP investment theses. The 'Fair Value' module has been transformed into a true Interactive Lab (adjust your own growth rates in real-time). We have also launched the Insider Radar, the Catalyst Calendar, and completely redesigned the Screener and navigation for an experience worthy of the best Wall Street terminals.",
            "features": ["AI Copilot (Gemini 2.5)", "Interactive Valuation Lab", "Insider Radar & Calendar", "New GARP Screener & Premium UX"]
          },
          {
            "id": 10,
            "date": "Jan 31, 2026",
            "category": "Major",
            "title": "Complete Financial Terminal",
            "color": "rose",
            "content": "The stock sheet reaches its final version! Explore revenue breakdown via the new interactive Sankey diagram, view analyst price targets and estimates (Future Revenue & EPS), and follow stock-specific news. We have also stabilized the loading of financial data and optimized the overall architecture.",
            "features": ["Sankey Flow Diagram", "Analyst Estimates & Targets", "News Feed", "Backend Optimization"]
          },
          {
            "id": 9,
            "date": "Jan 27, 2026",
            "category": "Major",
            "title": "Analytics 2.0 & Reliability",
            "color": "emerald",
            "content": "A critical update for the accuracy of your data. We have rewritten the calculation engine to eliminate 'sawtooth' effects on performance curves (smart weekend management). The Correlation Matrix and Dividend Calendar have been made more robust: they now display even if the history of some stocks is incomplete. PDF generation has also been secured.",
            "features": ["Smooth Curves (Smart Fill)", "Robust Correlation", "Rolling Dividends (12 months)", "Secured PDF"]
          },
          {
            "id": 8,
            "date": "Jan 24, 2026",
            "category": "Major",
            "title": "Visual Comfort & Precision",
            "color": "purple",
            "content": "A major visual and functional update! The performance curve now compares your portfolio to the S&P 500 with absolute precision (red line). Analysis charts now display 100% of the details (no more 'Others' grouping). Moreover, you can manually enter dividends ('Collection') and justify your choices thanks to the new 'Logbook' field in transactions.",
            "features": ["Reliable S&P 500 Benchmark", "Logbook (Thesis)", "100% Detailed Analysis", "Manual Dividend Entry"]
          },
          {
            "id": 7,
            "date": "Jan 21, 2026",
            "category": "Major",
            "title": "Benchmark Performance & Future Dividends",
            "color": "blue",
            "content": "Measure your outperformance! The new Performance tab now compares your portfolio against the S&P 500 in real-time. We have also added the annual projection of your dividends (based on the last payout), 'Bagger' badges for your best holdings, and improved the IBKR import to handle currency conversions (Forex).",
            "features": ["S&P 500 Benchmark", "Estimated Dividends", "Forex Support (XML)", "'Bagger' Badges"]
          },
          {
            "id": 6,
            "date": "Jan 11, 2026",
            "category": "Major",
            "title": "Risk Management & Corporate Actions",
            "color": "orange",
            "content": "Your portfolio management goes to the next level. Analyze the true diversification of your assets with the new Correlation Matrix. We have also added full support for Corporate Actions (Splits, Spin-offs), editing of past transactions, and a unified Cash Ledger.",
            "features": ["Correlation Matrix", "Splits & Spin-offs Management", "Editing & Correction", "Cash & Dividend Ledger"]
          },
          {
            "id": 5,
            "date": "Jan 09, 2026",
            "category": "Major",
            "title": "IBKR Automation & Logbook",
            "color": "pink",
            "content": "A massive update: connect your Interactive Brokers account for automatic synchronization (Flex Query), analyze your real vs. projected dividends, and log your investment theses.",
            "features": ["Auto IBKR Sync", "XML Import", "Logbook", "Real Dividends"]
          },
          {
            "id": 4,
            "date": "Jan 08, 2026",
            "category": "Feature",
            "title": "360° Fundamental Analysis & Profile",
            "color": "indigo",
            "content": "We have transformed the Stock page into a professional analysis terminal. Now access complete 5-year financial statements (Balance Sheet, Income, Cash Flow), geographic revenue breakdown, analyst estimates, and an exclusive dividend safety score. A Profile page has also been added.",
            "features": ["5-Year Financial Statements", "Revenue Breakdown", "Estimates & Targets", "Dividend & Buyback Score"]
          },
          {
            "id": 3,
            "date": "Oct 25, 2025",
            "category": "Feature",
            "title": "The Screener has arrived!",
            "color": "blue",
            "content": "Filter over 50,000 stocks by market cap, sector, and country.",
            "features": ["Multi-criteria filters", "Add to Watchlist", "Direct purchase"]
          },
          {
            "id": 2,
            "date": "Oct 20, 2025",
            "category": "Improvement",
            "title": "Charts & Analysis",
            "color": "green",
            "content": "New detail page with interactive history and Peter Lynch method.",
            "features": ["5-year chart", "Fair Value", "CAGR"]
          },
          {
            "id": 1,
            "date": "Oct 01, 2025",
            "category": "Launch",
            "title": "KeyForIn v1.0",
            "color": "purple",
            "content": "Official launch. Manage your stock portfolios simply.",
            "features": ["Multi-portfolios", "Avg Cost Calculation", "Currency Tracking"]
          }
        ]
      },
      "login": {
        "error_msg": "Incorrect credentials or account pending validation.",
        "badge_philo": "KeyForIn Philosophy",
        "title_main": "Growth at a Reasonable Price Strategy",
        "title_garp": "(GARP)",
        "subtitle": "This approach aims to identify and hold outstanding companies over the long term, without overpaying for their value.",
        "step1_title": "1. Quality (Fisher & Buffett)",
        "step1_desc": "We look for companies with a sustainable competitive advantage (\"moat\") ensuring high profits for decades to come.",
        "step2_title": "2. Growth (Peter Lynch)",
        "step2_desc": "Quality is not enough without perspective. We target revenue and earnings growth above the market average.",
        "step3_title": "3. Discipline (Graham)",
        "step3_desc": "Even the best company is a bad investment if overpaid. We wait for the fair price.",
        "horizon": "Long-term \"Buy and Hold\" horizon",
        "welcome_back": "Welcome back!",
        "login_desc": "Log in to access the Cockpit.",
        "email_label": "User Email",
        "email_placeholder": "john@example.com",
        "password_label": "Password",
        "password_placeholder": "••••••••",
        "btn_loading": "Logging in...",
        "btn_login": "Log In",
        "no_account": "Don't have access to the Club yet?",
        "btn_register": "Submit an application"
      },
      "register": {
        "error_msg": "Application error. This email might already be under review.",
        "club": "KeyForIn Club",
        "title_p1": "Join the elite of",
        "title_p2": "Investors.",
        "subtitle": "Access to the platform is strictly reserved. Submit your application to unlock our institutional analysis tools.",
        "feat1": "Custom financial cockpit",
        "feat2": "Screener & Smart DCA Algorithm",
        "feat3": "Access to Guru portfolios",
        "process_title": "Selection Process",
        "process_desc": "Each application is manually reviewed by the administrator to ensure the quality of the network.",
        "success_title": "Application Received!",
        "success_desc": "Thank you for your interest in KeyForIn. The administrator will review your profile. You will receive a notification as soon as your access is unlocked.",
        "btn_home": "Back to home",
        "form_title": "Submit an Application",
        "form_subtitle": "Please fill out the form below accurately.",
        "label_name": "Full Name",
        "place_name": "Ex: John Doe",
        "label_email": "Contact Email",
        "place_email": "john@example.com",
        "label_pwd": "Desired Password",
        "place_pwd": "••••••••",
        "label_obj": "Your objective (Optional)",
        "place_obj": "Why do you want to join the platform? (e.g., Manage my portfolio, analyze US stocks...)",
        "btn_loading": "Sending...",
        "btn_submit": "Submit my application",
        "already_member": "Already have access?",
        "login_here": "Log in here"
      },
      "screener": {
        "badge": "Search Engine",
        "title": "GARP Screener",
        "subtitle": "Filter global markets to find the best opportunities.",
        "label_region": "Geographic Region",
        "region_world": "Worldwide",
        "region_us": "United States",
        "region_fr": "France",
        "region_de": "Germany",
        "region_uk": "United Kingdom",
        "region_cn": "China",
        "label_cap": "Market Capitalization",
        "cap_all": "All sizes",
        "cap_micro": "Micro Cap (> $50M)",
        "cap_small": "Small Cap (> $300M)",
        "cap_mid": "Mid Cap (> $2B)",
        "cap_large": "Large Cap (> $10B)",
        "cap_mega": "Mega Cap (> $200B)",
        "label_sector": "Business Sector",
        "sector_all": "All sectors",
        "label_search": "Search by Name",
        "place_search": "Ex: Apple, NVDA...",
        "check_etf": "Include ETFs",
        "check_fund": "Include Funds",
        "btn_apply": "Apply filters",
        "results_found": "Results found",
        "empty_search": "Searching...",
        "empty_title": "No gems found",
        "empty_desc": "Adjust your filters above to find more opportunities.",
        "col_symbol": "Symbol",
        "col_company": "Company",
        "col_sector_country": "Sector & Country",
        "col_price": "Price",
        "col_cap": "Market Cap",
        "col_actions": "Actions",
        "action_buy": "Buy",
        "action_watch": "Watchlist",
        "action_analyze": "Analyze",
        "modal_buy_title": "Buy",
        "modal_buy_dest": "Destination Portfolio",
        "modal_buy_qty": "Quantity",
        "modal_buy_price": "Unit Price",
        "modal_buy_btn": "Execute Order",
        "modal_watch_title": "Add to Watchlist",
        "modal_watch_select": "Select list for",
        "modal_watch_btn": "Add to favorites",
        "alert_buy": "Order executed!",
        "alert_watch": "Added!"
      },
      "valuation": {
        "badge": "Interactive Lab",
        "title": "Fair Value",
        "subtitle": "Modify growth assumptions to observe the impact on the Margin of Safety.",
        "placeholder": "Ex: AAPL, TSLA, MSFT...",
        "btn_analyze": "Analyze",
        "eps_base": "Base Earnings Per Share (EPS):",
        "gauge_invalid": "Unsuitable model (Negative earnings or insufficient data).",
        "fair_value": "Fair Value",
        "current_price": "Current",
        "dcf_title": "DCF Model (Earnings)",
        "dcf_desc": "Discounting future earnings (Earnings DCF) based on your growth assumptions.",
        "dcf_growth": "Estimated growth (1-5 years)",
        "dcf_discount": "Discount Rate",
        "dcf_terminal": "Terminal Multiple",
        "graham_title": "Graham Formula",
        "graham_desc": "Valuation based on Benjamin Graham's principles adapted to your scenario.",
        "graham_growth": "Long-term growth (g)",
        "graham_default": "FMP default estimate:",
        "histpe_title": "Historical P/E Model",
        "histpe_desc": "Mean reversion simulation. Adjust the target P/E against the historical average.",
        "histpe_target": "Target P/E",
        "histpe_avg": "5-year stock average:",
        "comp_title": "Comparables Model",
        "comp_desc": "Relative valuation. Adjust the sector P/E to simulate a leadership premium.",
        "comp_sector": "Sector P/E",
        "comp_median": "Median of {{count}} peers:",
        "verdict_title": "Your Simulation Verdict",
        "verdict_models": "{{undervalued}} out of {{total}} models",
        "verdict_discount": "estimate that the stock offers a discount with your assumptions.",
        "verdict_good": "The consensus indicates a significant margin of safety. It's a potential opportunity.",
        "verdict_bad": "The stock appears to be trading at a premium, caution with these assumptions.",
        "verdict_neutral": "The company is currently valued at a price close to its theoretical Fair Value.",
        "avg_title": "Average Fair Value",
        "avg_margin": "Overall margin:",
        "footer_note": "Slider modifications update the valuation in real-time without reloading the page.",
        "alert_not_found": "not found.",
        "alert_error": "Connection error."
      },
      "arena": {
        "title": "Titan Arena",
        "subtitle": "Analyze official portfolios (SEC 13F) from legends.",
        "btn_consensus": "Top 10 Consensus",
        "btn_sync_all": "Update All",
        "btn_syncing": "Updating...",
        "search_ph": "Search...",
        "alert_sync": "Update launched!",
        "alert_sync_all": "Run full update?",
        "alert_sync_all_ok": "🚀 Global update launched.",
        "alert_error": "Error",
        "guru_update": "Updated:",
        "guru_never": "Never",
        "guru_btn_sync": "Individual Sync",
        "guru_assets": "Assets Under Management",
        "guru_positions": "Positions",
        "guru_turnover": "Turnover",
        "guru_hold_period": "Holding Period",
        "guru_months": "M",
        "allocation_title": "Allocation",
        "allocation_empty": "No data",
        "holdings_title": "Top Holdings",
        "holdings_empty": "No positions.",
        "col_symbol": "Symbol",
        "col_company": "Company",
        "col_type": "Type",
        "col_value": "Value",
        "col_weight": "Weight",
        "empty_select": "Select an investor on the left or click 'Top 10 Consensus'",
        "cons_title": "Top 10 Consensus",
        "cons_desc": "The most favored stocks by the {{count}} super investors in your database.",
        "cons_loading": "Calculating consensus...",
        "cons_col_rank": "Rank",
        "cons_col_holders": "Holders",
        "cons_col_invested": "Total Invested"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
